// vuex 在页面刷新时会重置，先缓存在会话存储中
// 大写为了引起注意
export default {
  // 设置用户信息
  SET_USER_INFO (state, data) {
    state.userInfo = data
    localStorage.setItem('userInfo', JSON.stringify(data))
  },
  // 设置登录后的基本信息
  SET_BASE_INFO (state, data) {
    state.baseInfo = data
    localStorage.setItem('baseInfo', JSON.stringify(data))
  },
  // 设置项目信息
  SET_PROJECT_INFO (state, data) {
    state.projectInfo = data
    localStorage.setItem('projectInfo', JSON.stringify(data))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js